import {
    PendingSubmissionsResults,
} from '../../Models/Api/strongbox.financialportal';
import { ListPendingSubmissions } from '../../Services/SubmissionService';
import { LogException } from '../../Utils/Logging';
import {
    AppThunkActionAsync
} from '../index';
import * as actions from './Actions';
import {
    JobUpdateRecord,
    KnownAction,
    RunningImportsStateActions,
} from './Actions';


function UpdateJobs(updates: JobUpdateRecord[]): actions.IUpdateJobStatus {
    return {
        type: actions.RunningImportsStateActions.UpdateJobStatus,
        updates,
    };
}

function DismissJob(financialRecordId: string, workspaceId: string): actions.IDismissJob {
    return {
        type: actions.RunningImportsStateActions.DismissJob,
        financialRecordId,
        workspaceId,
    };
}

function DismissMultipleJobs(jobs: { financialRecordId: string, workspaceId: string }[]): actions.IDismissMultipleJobs {
    return {
        type: actions.RunningImportsStateActions.DismissMultipleJobs,
        jobs,
    };
}

const ListPendingJobs = (returnAll?: boolean): AppThunkActionAsync<void, KnownAction> =>
    async (dispatch, getState): Promise<void> => {
        let pendingResults: PendingSubmissionsResults | undefined = undefined;
        const appState = getState();

        dispatch({
            type: RunningImportsStateActions.ListPendingJobs,
            returnAll: !!returnAll,
        });

        const pendingSubsVersion =
            (appState &&
                appState.runningImportsState &&
                appState.runningImportsState.pendingSubmissionsResults &&
                appState.runningImportsState.pendingSubmissionsResults.tenantPendingSubmissionVersion) || 0;

        try {
            pendingResults = await ListPendingSubmissions(
                returnAll,
                undefined,
                pendingSubsVersion,
            );

            dispatch({
                type: RunningImportsStateActions.ListPendingJobsComplete,
                pendingSubmissionResults: pendingResults,
                returnAll: !!returnAll,
            });
        } catch (ex) {
            const errorMsg = 'Failure in ListPendingJobs action creator';

            console.error(errorMsg);
            console.error(ex);

            LogException(errorMsg, ex);

            dispatch({
                type: RunningImportsStateActions.ListPendingJobsComplete,
                returnAll: !!returnAll,
            });
        }
    }

function UpdateLoggedInUserAccess(workspaceId: string, hasAccess: boolean): actions.IUpdateLoggedInUserAccess {
    return {
        type: RunningImportsStateActions.UpdateLoggedInUserAccess,
        hasAccess,
        workspaceId
    };
}

function ValidateRunningImportsConsumer(consumerId: string): actions.IValidateRunningImportsConsumer {
    return {
        type: RunningImportsStateActions.ValidateRunningImportsConsumer,
        consumerId,
    };
}

export const actionCreators = {
    DismissJob: DismissJob,
    DismissMultipleJobs: DismissMultipleJobs,
    UpdateJobs: UpdateJobs,
    ListPendingJobs: ListPendingJobs,
    UpdateLoggedInUserAccess: UpdateLoggedInUserAccess,
    ValidateRunningImportsConsumer: ValidateRunningImportsConsumer,
};
